const validText = /^[a-zA-Z0-9 \-?!$.,/()@:;'‘’“”"_#+=%^&*<>~`{}|\n\\]*$/;

export { validText }
